import useAxios from 'axios-hooks';
import React, { useEffect, useState } from 'react';
import FeaturedList from './FeaturedList';

const Tags = ({moveItem, addItem, saveIndividual, showUpdateBtn, removeItem, cobrandId, model}) => {
  const [{ data, loading }] = useAxios({ url: `internal/cobrand/tags/${cobrandId ? cobrandId : ''}`, method: "get" });
    return (
        <FeaturedList 
        moveItem={(index, direction) => moveItem("tags", index, direction)}
        addItem={(option) => addItem("tags", option)}
        removeItem={(id) => removeItem("tags", id)}
        saveIndividual={saveIndividual}
        showUpdateBtn={showUpdateBtn}
        typeId={9}
        type="Tag" model={model} availableItems={data} />
    );
};

export default Tags;